import i18next from "i18next";

import { GraphQLClient, gql } from "graphql-request";

const CLIENT_TOKEN =
  process.env.NODE_ENV === "development"
    ? process.env.API_CLIENT_TOKEN
    : window.location.pathname.split("/")[2];

const client = new GraphQLClient(`${process.env.API_URL}/graphql`, {
  headers: () => ({
    "Client-Token": CLIENT_TOKEN as string,
    "Accept-Language": i18next.language,
  }),
});

export { gql, client };
